import typeSerializerMap from "./serializers";

export type SerializerOptions<T extends object = any, P extends object = any> = {
  level: number,
  parent?: P,
  parentKey?: keyof T
}

export function defaultSerializer<T extends { __typename?: any }, P extends object = any>(entity: T, options: SerializerOptions<T, P>): Partial<T> | null {
  if (entity.hasOwnProperty("id") || entity.hasOwnProperty("temporalId")) {
    if (options.level === 0) {
      return ({
        ...entity,
        __label: undefined,
        __typename: undefined,
        createdAt: undefined,
        createdByUser: undefined,
        createdByUserId: undefined,
        updatedAt: undefined,
        updatedByUser: undefined,
        updatedByUserId: undefined,
      });
    } else {
      if (entity.hasOwnProperty("id")) {
        return ({
          id: (entity as any).id,
        }) as any as Partial<T>;
      } else if (entity.hasOwnProperty("temporalId")) {
        return ({
          temporalId: (entity as any).temporalId,
        }) as any as Partial<T>;
      }
    }
  }
  return ({
    ...entity,
    __label: undefined,
    __typename: undefined,
    createdAt: undefined,
    createdByUser: undefined,
    createdByUserId: undefined,
    updatedAt: undefined,
    updatedByUser: undefined,
    updatedByUserId: undefined,
  });
}

function getSerializer(typename: string) {
  if (typeSerializerMap.has(typename)) {
    return typeSerializerMap.get(typename);
  }
  return defaultSerializer;
}

export function serializeEntity<T extends object = any, P extends object = any>(entity: T, options?: SerializerOptions<T, P>) {
  const level = options?.level || 0;

  let serializedValue = entity;
  if (entity.hasOwnProperty("__typename")) {
    serializedValue = getSerializer((entity as any).__typename)!(entity as any, {
      level,
      parent: options?.parent,
      parentKey: options?.parentKey,
    }) as T;
  }
  if (serializedValue) {
    serializedValue = Object
      .entries(serializedValue)
      .reduce((acc, [ key, fieldValue ]) => {
        const newOptions = {
          level: level + 1,
          parent: entity,
          parentKey: key,
        };

        return {
          ...acc,
          [key]: Array.isArray(fieldValue)
            ? fieldValue.map(x => (x instanceof Object ? serializeEntity(x, newOptions) : x))
            : (fieldValue instanceof Object ? serializeEntity(fieldValue, newOptions) : fieldValue),
        };
      }, {}) as T;
  }
  return serializedValue;
}
